import { ImgWithRatio } from '../../components/Player/Styles/Player.styles'
import { imageSrcBlockAds } from '../../styles/GlobalVariables'
export const BlockedAdsImage = () => {
  return (
    <ImgWithRatio
      loading='lazy'
      kalturaClass='AdsBlockIMG'
      src={imageSrcBlockAds}
    />
  )
}
